/** AppointmentsPageRoute — skin-aware switcher for /appointments. */
import AppointmentsPage from "./AppointmentsPage";

export default function AppointmentsPageRoute() {
  // AppointmentsPage renders its own CockpitMasthead, so we pass through
  // directly to avoid a redundant outer "Appointments" header above the
  // page's own "Appointment Command Center" title.
  return <AppointmentsPage />;
}
